<div class="container">
    <app-shared-action-bar [saveReady]="hasChanged" [undoReady]="hasChanged"
        [displayActionSectionBar]="showActionSectionBar" (saveRequest)="validateUser()"
        (undoRequest)="reset()"></app-shared-action-bar>
    <div class=" mt-20 mx-2 lg:mx-8">
        <h2 class="lg:mb-4 mb-2 settings-header">Profile</h2>
        <div class="mx-4 ">
            <p class="text-lg text-green-700 mb-4  font-bold">General Details</p>
            <div class="mb-4">
                <app-text-box-entry [(isEditing)]="isEditingName" (isEditingChange)="updateEditing()"
                    [(value)]="editingUser.DisplayName"></app-text-box-entry>
            </div>
            <div class="mb-4">
                <app-text-box-entry [(isEditing)]="isEditingEmail" (isEditingChange)="updateEditing()"
                    [(value)]="editingUser.Email"></app-text-box-entry>
            </div>

            <div class="xl:w-2/5 lg:w-3/5">
                <div class="mt-4 mb-6 mx-2 border-grey-500 border-b-2 border-solid"></div>
                <p class="text-lg text-green-700 mb-4 font-bold">Email Preferences</p>
                <div class="mx-2">
                    <div class="flex mb-4 justify-between items-center">
                        <label>Daily Reminders</label><app-toggle-switch [(checked)]="editingUser.DailyReminders"
                            (checkedChange)="checkChange()"></app-toggle-switch>
                    </div>
                    <div class="flex mb-4 justify-between items-center">
                        <label>Weekly Summary</label><app-toggle-switch [(checked)]="editingUser.WeeklySummary"
                            (checkedChange)="checkChange()"></app-toggle-switch>
                    </div>
                    <div class="flex mb-4 justify-between items-center">
                        <label>Daily Recaps</label><app-toggle-switch [(checked)]="editingUser.SendDailyRecaps"
                            (checkedChange)="checkChange()"></app-toggle-switch>
                    </div>
                    <div class="flex justify-between items-center">
                        <label>Action Emails</label><app-toggle-switch [(checked)]="editingUser.SendActionEmails"
                            (checkedChange)="checkChange()"></app-toggle-switch>
                    </div>
                </div>

            </div>
            <app-landing-page-preference></app-landing-page-preference>
        </div>
    </div>



</div>
